export const questions = [
    {
        id: 1,
        image: "/images/q1.jpg",
        question: "신비로운 숲의 입구에서 작은 정령이 당신의 소지품 하나를 빌려달라고 합니다. 무엇을 건네주겠습니까?",
        answers: [
            { text: "아픈 이를 위해 늘 챙겨두는 구급 약초", effects: { F: 1 } },
            { text: "날카롭게 빛나는 튼튼한 은색 단검", effects: { S: 1 } },
            { text: "먼 곳까지 가볍게 달릴 수 있는 낡은 부츠", effects: { A: 1 } },
            { text: "지도가 꼼꼼히 그려진 오래된 탐험 일지", effects: { M: 1 } }
        ]
    },
    {
        id: 2,
        image: "/images/q2.jpg",
        question: "하늘을 나는 커다란 기구가 고장이 났습니다! 당신은 어떤 역할을 자처할까요?",
        answers: [
            { text: "바람의 흐름을 읽고 나아갈 방향을 결정한다", effects: { M: 1 } },
            { text: "불안해하는 사람들의 손을 잡아주며 안심시킨다", effects: { F: 1 } },
            { text: "가장 먼저 뛰어들어 뜨거운 엔진을 수리한다", effects: { S: 1 } },
            { text: "밧줄을 타고 올라가 엉킨 그물망을 풀어낸다", effects: { A: 1 } }
        ]
    },
    {
        id: 3,
        image: "/images/q3.jpg",
        question: "비를 피해 들어간 오래된 오두막, 벽난로 앞에 놓인 물건 중 당신의 마음을 끄는 것은?",
        answers: [
            { text: "어디로든 떠날 수 있을 것 같은 낡은 망토", effects: { A: 1 } },
            { text: "수천 년의 역사가 기록된 두꺼운 마법서", effects: { M: 1 } },
            { text: "누군가를 지키기 위해 휘둘렀을 법한 묵직한 망치", effects: { S: 1 } },
            { text: "따뜻한 온기가 남아있는 누군가의 찻잔", effects: { F: 1 } }
        ]
    },
    {
        id: 4,
        image: "/images/q4.jpg",
        question: "갑자기 숲이 어두워지고 무서운 소리가 들립니다. 당신은 어떻게 행동하나요?",
        answers: [
            { text: "소리의 정체를 파악하기 위해 주위를 냉정하게 분석한다", effects: { M: 1 } },
            { text: "빠르게 달아나 몸을 숨길 수 있는 은신처를 찾는다", effects: { A: 1 } },
            { text: "겁먹지 않고 당당하게 소리가 나는 쪽으로 나선다", effects: { S: 1 } },
            { text: "함께 있는 동료를 품에 안고 등을 토닥여준다", effects: { F: 1 } }
        ]
    },
    {
        id: 5,
        image: "/images/q5.jpg",
        question: "비밀의 정원에서 단 한 가지 꽃만 꺾을 수 있다면, 당신의 선택은?",
        answers: [
            { text: "향기만으로도 슬픔을 잊게 해주는 치유의 백합", effects: { F: 1 } },
            { text: "폭풍우 속에서도 꺾이지 않고 피어난 강인한 들꽃", effects: { S: 1 } },
            { text: "뿌리가 깊어 땅속의 진실을 알고 있을 것 같은 고목의 꽃", effects: { M: 1 } },
            { text: "씨앗이 바람을 타고 어디로든 멀리 날아가는 민들레", effects: { A: 1 } }
        ]
    },
    {
        id: 6,
        image: "/images/q6.jpg",
        question: "양탄자를 타고 구름 위를 날고 있습니다. 당신이 꿈꾸는 목적지는 어디인가요?",
        answers: [
            { text: "아무도 가본 적 없는 전설 속의 도서관", effects: { M: 1 } },
            { text: "지도에도 없는, 발길 닿는 대로 펼쳐진 끝없는 지평선", effects: { A: 1 } },
            { text: "사랑하는 사람들이 평화롭게 기다리고 있는 작은 마을", effects: { F: 1 } },
            { text: "용과 거인들이 대결을 펼치는 거친 산맥의 정상", effects: { S: 1 } }
        ]
    },
    {
        id: 7,
        image: "/images/q7.jpg",
        question: "상처 입은 작은 정령이 길가에 쓰러져 있습니다. 당신은 어떻게 보듬어줄까요?",
        answers: [
            { text: "정령이 안전할 수 있도록 주변에 튼튼한 울타리를 만든다", effects: { S: 1 } },
            { text: "정령의 기록을 찾아 어떤 음식을 좋아하는지 조사한다", effects: { M: 1 } },
            { text: "노래를 불러주고 정성을 다해 상처를 치료해준다", effects: { F: 1 } },
            { text: "기운을 차린 정령이 다시 날아오를 수 있게 자유를 준다", effects: { A: 1 } }
        ]
    },
    {
        id: 8,
        image: "/images/q8.jpg",
        question: "마녀가 당신의 소원 한 가지를 들어주겠다고 합니다. 무엇을 원하나요?",
        answers: [
            { text: "어떤 시련에도 흔들리지 않는 굳건한 의지", effects: { S: 1 } },
            { text: "모든 아픔과 미움을 녹여버릴 수 있는 사랑", effects: { F: 1 } },
            { text: "새처럼 구속받지 않고 세상을 떠돌 수 있는 날개", effects: { A: 1 } },
            { text: "세상의 모든 비밀을 풀 수 있는 명석한 두뇌", effects: { M: 1 } }
        ]
    },
    {
        id: 9,
        image: "/images/q9.jpg",
        question: "마을 축제에서 당신이 가장 즐겁게 참여하고 싶은 역할은?",
        answers: [
            { text: "마을의 질서를 유지하고 아이들을 보호하는 파수꾼", effects: { S: 1 } },
            { text: "축제의 흥을 돋우기 위해 자유로운 춤을 추는 무용수", effects: { A: 1 } },
            { text: "축제에 쓰일 화려한 등불과 장치를 설계하는 기술자", effects: { M: 1 } },
            { text: "모든 사람에게 따뜻한 음식을 나눠주는 배급가", effects: { F: 1 } }
        ]
    },
    {
        id: 10,
        image: "/images/q10.jpg",
        question: "거센 폭풍우가 몰아쳐 마을이 위태롭습니다. 당신이 가장 먼저 지켜낼 것은?",
        answers: [
            { text: "마을 사람들의 생명과 건강을 지키는 약 저장고", effects: { F: 1 } },
            { text: "무너지는 둑을 막아낼 수 있는 가장 튼튼한 방벽", effects: { S: 1 } },
            { text: "폭풍우가 지나간 뒤 다시 시작할 수 있는 씨앗 주머니", effects: { A: 1 } },
            { text: "다시 마을을 재건할 수 있는 설계도와 기록물", effects: { M: 1 } }
        ]
    },
    {
        id: 11,
        image: "/images/q11.jpg",
        question: "밤하늘에 별똥별이 떨어지는 순간, 찰나에 스쳐 지나간 생각은?",
        answers: [
            { text: "이 별똥별이 어디서 왔는지 그 원리를 알고 싶어", effects: { M: 1 } },
            { text: "누군가 이 별을 보고 소원을 빌며 행복해지길", effects: { F: 1 } },
            { text: "나도 저 별처럼 어디든 훌쩍 떠나보고 싶어", effects: { A: 1 } },
            { text: "나에게 어떤 역경도 이겨낼 힘을 주었으면", effects: { S: 1 } }
        ]
    },
    {
        id: 12,
        image: "/images/q12.jpg",
        question: "안개가 걷히고 현실로 돌아오는 순간, 천사가 당신의 손을 살며시 놓으며 속삭입니다.?",
        answers: [
            { text: "눈에 보이는 것 너머, 마음의 눈으로 세상을 읽어내렴", effects: { M: 1 } },
            { text: "네가 흘린 눈물조차 누군가에겐 따스한 비가 되어 내릴 거야", effects: { F: 1 } },
            { text: "바람은 언제나 불고 있어. 넌 그저 날개를 펴기만 하면 돼", effects: { A: 1 } },
            { text: "너의 안에 이미 거대한 폭풍을 잠재울 힘이 있음을 잊지 마", effects: { S: 1 } }
        ]
    }
];